// extracted by mini-css-extract-plugin
export default {"animatedDot":"WithAnimatedEllipsis-module__animatedDot--Dbgsr"};